
  var storagePrefix = 'bi_secret_bogo_';
  var duration = 48 * 60 * 60 * 1000;
  var refreshTimer = null;

  function normalizeCampaign(value) {
  return (value || '')
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\+/g, ' ')
    .replace(/\s+/g, ' ');
}

  var params = new URLSearchParams(window.location.search);
  var utmCampaign = normalizeCampaign(params.get('utm_campaign'));

  if (utmCampaign) {
    localStorage.setItem(storagePrefix + utmCampaign, String(Date.now() + duration));
  }


  function updateGridNewBadges(root) {
  root = root || document;

  root.querySelectorAll('.product-item').forEach(function (card) {
    var newBadge = null;

    card.querySelectorAll('.badge-box').forEach(function (badge) {
      if (badge.textContent.trim().toUpperCase() === 'NEW') {
        newBadge = badge;
      }
    });

    if (!newBadge) return;

    var hasSaleBadge = !!card.querySelector('.badge-sale, .badge-sale-grid');
    if (hasSaleBadge) {
      return;
    }

    var hasVisibleBogo = false;

    card.querySelectorAll('.bogo-badge').forEach(function (bogo) {
      if (window.getComputedStyle(bogo).display !== 'none') {
        hasVisibleBogo = true;
      }
    });

    if (hasVisibleBogo) {
      newBadge.classList.add('badge--bottom-left');
    } else {
      newBadge.classList.remove('badge--bottom-left');
    }
  });
}


  function bdkBadgeIsVisible(el) {
    if (!el) return false;

    var style = window.getComputedStyle(el);

    /* Do not use opacity here.
       Existing BADINKA badges can temporarily start at opacity:0 because
       of entrance animations. They still occupy a logical badge slot. */
    return !(
      style.display === 'none' ||
      style.visibility === 'hidden'
    );
  }

  function bdkHasVisibleBadge(scope, selector, handmade) {
    var elements = scope.querySelectorAll(selector);

    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (el === handmade || el.contains(handmade)) continue;
      if (bdkBadgeIsVisible(el)) return true;
    }

    return false;
  }

  function bdkSetHandmadeSlot(handmade, slot, shippingBadge) {
    handmade.classList.remove(
      'badge--bottom-left',
      'handmade-badge--bottom-right'
    );
    handmade.style.removeProperty('--bdk-handmade-bottom');

    if (slot === 'bottom-left') {
      /* Reuse BADINKA's existing secondary-badge class.
         This guarantees identical offsets to NEW / BACK IN STOCK. */
      handmade.classList.add('badge--bottom-left');
    } else if (slot === 'bottom-right') {
      handmade.classList.add('handmade-badge--bottom-right');

      if (shippingBadge && bdkBadgeIsVisible(shippingBadge)) {
        var shippingStyle = window.getComputedStyle(shippingBadge);
        var shippingBottom = parseFloat(shippingStyle.bottom);

        /* Desktop PDP can place SHIPS IN 24h top-right, so stack only
           when the shipping badge is actually bottom-anchored. */
        if (!isNaN(shippingBottom) && shippingStyle.bottom !== 'auto') {
          var shippingHeight = shippingBadge.getBoundingClientRect().height;
          var handmadeBottom = shippingBottom + shippingHeight + 8;

          handmade.style.setProperty(
            '--bdk-handmade-bottom',
            handmadeBottom + 'px'
          );
        }
      }
    }

    /* Top-left intentionally gets no positioning modifier:
       native .badge-box / .badge-box-new-product-page owns the geometry. */
    handmade.setAttribute('data-bdk-handmade-slot', slot);
    handmade.setAttribute('data-bdk-handmade-resolved', 'true');
  }

  function bdkResolveCardHandmade(card) {
    var handmade = card.querySelector(
      '[data-bdk-badge-role="handmade"][data-bdk-badge-surface="card"]'
    );
    if (!handmade) return;

    var topLeftOccupied = bdkHasVisibleBadge(
      card,
      [
        '.bogo-badge',
        '.bf-bogo-badge',
        '.badge-sale-grid',
        '.preorder-box',
        '.sale-box',
        '.badge-box:not(.handmade-badge):not(.badge--bottom-left):not(.ships-24h-badge)'
      ].join(','),
      handmade
    );

    var bottomLeftOccupied = bdkHasVisibleBadge(
      card,
      '.badge--bottom-left:not(.handmade-badge)',
      handmade
    );

    var shippingBadge = card.querySelector('.ships-24h-badge');

    if (!topLeftOccupied) {
      bdkSetHandmadeSlot(handmade, 'top-left', shippingBadge);
    } else if (!bottomLeftOccupied) {
      bdkSetHandmadeSlot(handmade, 'bottom-left', shippingBadge);
    } else {
      bdkSetHandmadeSlot(handmade, 'bottom-right', shippingBadge);
    }
  }

  function bdkResolvePdpHandmade(slide) {
    var handmade = slide.querySelector(
      '[data-bdk-badge-role="handmade"][data-bdk-badge-surface="pdp"]'
    );
    if (!handmade || !bdkBadgeIsVisible(handmade)) return;

    var topLeftOccupied = bdkHasVisibleBadge(
      slide,
      [
        '.bogo-badge-product-page',
        '.bf-bogo-badge',
        '.badge-sale.badge-box-new-product-page',
        '.sale-box-product-page',
        '.badge-box-new-product-page:not(.badge--bottom-left)'
      ].join(','),
      handmade
    );

    var bottomLeftOccupied = bdkHasVisibleBadge(
      slide,
      '.badge-box-new-product-page.badge--bottom-left',
      handmade
    );

    var shippingBadge = slide.querySelector('.ships-24h-badge-pdp');

    if (!topLeftOccupied) {
      bdkSetHandmadeSlot(handmade, 'top-left', shippingBadge);
    } else if (!bottomLeftOccupied) {
      bdkSetHandmadeSlot(handmade, 'bottom-left', shippingBadge);
    } else {
      bdkSetHandmadeSlot(handmade, 'bottom-right', shippingBadge);
    }
  }

  function updateHandmadeBadges(root) {
    root = root || document;

    if (root.matches && root.matches('.product-item')) {
      bdkResolveCardHandmade(root);
    }

    if (root.matches && root.matches('.product__slide')) {
      bdkResolvePdpHandmade(root);
    }

    root.querySelectorAll('.product-item').forEach(function (card) {
      bdkResolveCardHandmade(card);
    });

    root.querySelectorAll('.product__slide').forEach(function (slide) {
      bdkResolvePdpHandmade(slide);
    });
  }

  function hasActiveCampaignContains(campaignNeedle) {
    campaignNeedle = normalizeCampaign(campaignNeedle);
    if (!campaignNeedle) return false;

    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      if (!key || key.indexOf(storagePrefix) !== 0) continue;

      var storedCampaign = normalizeCampaign(key.replace(storagePrefix, ''));
      var expiresAt = parseInt(localStorage.getItem(key) || '0', 10);

      if (expiresAt <= Date.now()) {
        localStorage.removeItem(key);
        i--;
        continue;
      }

      if (storedCampaign.indexOf(campaignNeedle) !== -1) {
        return true;
      }
    }

    return false;
  }
function matchesSecretCampaign(campaign1, campaign2) {
  campaign1 = normalizeCampaign(campaign1);
  campaign2 = normalizeCampaign(campaign2);

  return (
    (campaign1 && hasActiveCampaignContains(campaign1)) ||
    (campaign2 && hasActiveCampaignContains(campaign2))
  );
}
 function updateSecretBogoLayout(el, visible) {
  var layout = el.closest('[data-secret-bogo-layout]');
  if (!layout) return;

  var hiddenClass = layout.getAttribute('data-secret-bogo-hidden-class');
  if (!hiddenClass) return;

  layout.classList.toggle(hiddenClass, !visible);
}
 function isAnySecretBogoActive() {
  for (var i = 0; i < localStorage.length; i++) {
    var key = localStorage.key(i);
    if (!key || key.indexOf(storagePrefix) !== 0) continue;

    var expiresAt = parseInt(localStorage.getItem(key) || '0', 10);
    if (expiresAt > Date.now()) {
      return true;
    }
  }

  return false;
}

  function toggleSecretBogoMenuState() {
    if (isAnySecretBogoActive()) {
      document.body.classList.add('secret-bogo-active');
    } else {
      document.body.classList.remove('secret-bogo-active');
    }
  }

  function refreshSecretBogo(root) {
    root = root || document;

   root.querySelectorAll('.js-secret-bogo').forEach(function (el) {
  var isSecret = el.getAttribute('data-secret-bogo') === 'true';
  var mode = el.getAttribute('data-secret-mode') || 'only';
  var campaign1 = el.getAttribute('data-secret-campaign');
  var campaign2 = el.getAttribute('data-secret-campaign-2');
  var matched = matchesSecretCampaign(campaign1, campaign2);

  var visible = true;

  if (!isSecret) {
    el.style.display = '';
  } else if (mode === 'only') {
    visible = matched;
    el.style.display = visible ? '' : 'none';
  } else if (mode === 'hide') {
    visible = !matched;
    el.style.display = visible ? '' : 'none';
  }

  updateSecretBogoLayout(el, visible);
});

   document.querySelectorAll('.bogo-cart-wrapper.js-secret-bogo').forEach(function (wrapper) {
  var isSecret = wrapper.getAttribute('data-secret-bogo') === 'true';
  var campaign1 = wrapper.getAttribute('data-secret-campaign');
  var campaign2 = wrapper.getAttribute('data-secret-campaign-2');
  var matched = matchesSecretCampaign(campaign1, campaign2);

  if (!isSecret) {
    wrapper.style.display = '';
  } else if (matched) {
    wrapper.style.display = '';
  } else {
    wrapper.style.display = 'none';
  }
});

toggleSecretBogoMenuState();
updateGridNewBadges(root);
updateHandmadeBadges(root);
  }

  function queueRefresh(root) {
    if (refreshTimer) return;

    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      refreshSecretBogo(root || document);
    }, 120);
  }

  refreshSecretBogo(document);

  document.addEventListener('shopify:section:load', function (event) {
    queueRefresh(event.target || document);
  });

  /* SHIPS IN 24h changes dynamically with PDP variant selection. */
  document.addEventListener('change', function (event) {
    var target = event.target;

    if (
      target &&
      target.matches &&
      target.matches('input[data-single-option-selector]')
    ) {
      queueRefresh(document);
    }
  });

  var observer = new MutationObserver(function (mutations) {
    var shouldRefresh = false;

    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      for (var j = 0; j < mutation.addedNodes.length; j++) {
        var node = mutation.addedNodes[j];
        if (!node || node.nodeType !== 1) continue;

        if (
          (node.matches && (
            node.matches('.js-secret-bogo') ||
            node.matches('.product-item') ||
            node.matches('.grid-item') ||
            node.matches('.product__slide') ||
            node.matches('[data-related-section]') ||
            node.matches('.recent__content')
          )) ||
          (node.querySelector && (
            node.querySelector('.js-secret-bogo') ||
            node.querySelector('.product-item') ||
            node.querySelector('.product__slide')
          ))
        ) {
          shouldRefresh = true;
          break;
        }
      }

      if (shouldRefresh) break;
    }

    if (shouldRefresh) {
      queueRefresh(document);
    }
  });

    var observerTargets = [];

  document.querySelectorAll(
    '.collection__products, .product-grid, .collection-grid, .grid, [data-related-section], .recent__content, .drawer__inner, #cart-drawer, cart-drawer'
  ).forEach(function (el) {
    observerTargets.push(el);
  });

  if (!observerTargets.length) {
    var fallbackMain = document.querySelector('.main-content');
    if (fallbackMain) observerTargets.push(fallbackMain);
  }

  observerTargets.forEach(function (target) {
    observer.observe(target, {
      childList: true,
      subtree: true
    });
  });